export default __webpack_public_path__ + "static/media/manage.ab39e248.png";